// Header - focuses the search input when the mobile search bar is toggled
// open (.header gets is-search-active via data-toggle). Behavioral port of
// v1 modules/Header.js; the HTML contract is unchanged.

import { TOGGLE_EVT, isToggled, type ToggleEventDetail } from './toggle';

export interface HeaderConfig {
  selector: string;
  searchSelector: string;
}

const defaultConfig: Omit<HeaderConfig, 'selector'> = {
  searchSelector: '.header-search__search input',
};

export default class Header {
  config: HeaderConfig;

  header: Element | null = null;

  searchInput: HTMLElement | null = null;

  constructor(selector = '.header', config: Partial<HeaderConfig> = {}) {
    this.config = { ...defaultConfig, selector, ...config };

    this._init();
  }

  update = (): void => {
    this.destroy();
    this._init();
  };

  destroy = (): void => {
    document.removeEventListener(TOGGLE_EVT, this._focusSearchOnSearchActive);
  };

  private _init = (): void => {
    this.header = document.querySelector(this.config.selector);

    if (!this.header) {
      return;
    }

    this.searchInput = this.header.querySelector<HTMLElement>(this.config.searchSelector);

    if (this.searchInput) {
      document.addEventListener(TOGGLE_EVT, this._focusSearchOnSearchActive);
    }
  };

  private _focusSearchOnSearchActive = (e: Event): void => {
    const { target } = (e as CustomEvent<ToggleEventDetail>).detail;

    if (target === this.header && isToggled(target, 'is-search-active')) {
      this.searchInput?.focus();
    }
  };
}
